import { render, staticRenderFns } from "./CollectionOrder.vue?vue&type=template&id=47433842&"
import script from "./CollectionOrder.vue?vue&type=script&lang=js&"
export * from "./CollectionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports